import {connect, type ConnectedProps} from 'react-redux';
import {bindActionCreators, type Dispatch, type ActionCreatorsMapObject} from 'redux';

import {makeGetFilesForPost} from 'mattermost-redux/selectors/entities/files';
import {getConfig} from 'mattermost-redux/selectors/entities/general';
import {type Post} from 'mattermost-redux/types/posts';
import {type GenericAction} from 'mattermost-redux/types/actions';
import {toggleEmbedVisibility} from 'actions/post_actions';

import {getFilePublicLink} from 'mattermost-redux/actions/files';

import {type GlobalState} from 'types/store';

import {getCurrentLocale} from 'selectors/i18n';
import {isEmbedVisible} from 'selectors/posts';
import {getFilesDropdownPluginMenuItems} from 'selectors/plugins';

import {openModal} from 'actions/views/modals';

import {canDownloadFiles} from 'utils/file_utils';

import {type ModalData} from 'types/actions';

import FileAttachmentList from './file_attachment_list';

export type OwnProps = {
    post: Post;
    compactDisplay?: boolean;
    isInPermalink?: boolean;
    interactive?: boolean;
    handleFileDropdownOpened?: (open: boolean) => void;
}

type Actions = {
    openModal: <P>(modalData: ModalData<P>) => void;
    toggleEmbedVisibility: (postId: string) => void;
    getFilePublicLink: (fileId: string) => Promise<{ data: { link: string}}>;
}

function makeMapStateToProps() {
    const selectFilesForPost = makeGetFilesForPost();

    return function mapStateToProps(state: GlobalState, ownProps: OwnProps) {
        const fileInfos = selectFilesForPost(state, ownProps.post?.file_ids);
        const config = getConfig(state);

        return {
            fileInfos,
            canDownloadFiles: canDownloadFiles(config),
            enablePublicLink: config.EnablePublicLink === 'true',
            fileIds: ownProps?.post?.file_ids || [],
            isEmbedVisible: isEmbedVisible(state, ownProps.post?.id),
            locale: getCurrentLocale(state),
            pluginMenuItems: getFilesDropdownPluginMenuItems(state),
        };
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators<ActionCreatorsMapObject, Actions>({
            openModal,
            toggleEmbedVisibility,
            getFilePublicLink,
        }, dispatch),
    };
}

const connector = connect(makeMapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(FileAttachmentList);
